import React, {useEffect, useRef} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Lottie from "lottie-web";

import Animation from "./data.json";
import './styles.scss';

/**
 * Loader component that displays a lightbox with a loading animation.
 * 
 * @param {object} props 
 */
/* If className is not set, set it to un empty string, otherwise it would be undefined. */
function Loader({className = "", appendTo, ...props}) {

    const svgRef = useRef();

    useEffect(() => {
        Lottie.loadAnimation({
            container: svgRef.current,
            animationData: Animation,
            renderer: "svg", // "canvas", "html"
            loop: true,
            autoplay: true,
        });
    }, []);

    const JSX_LOADER = (
        <div className={`animated-loader ${className}`}>
            <div className="animated-loader-inner" ref={svgRef}>
                <span className="animated-loader-text">{props.loadingText}</span>
            </div>
        </div>
    )

    return ReactDOM.createPortal(JSX_LOADER, document.querySelector(appendTo));

}

Loader.propTypes = {
    /** A selector that should be used to indicate where to append the loader to within the DOM. */
    appendTo: PropTypes.string,
    /** Additional classNames that can be supplied to the button element. */
    className: PropTypes.string,
    /** Text that is displayed when the loader is visible. */
    loadingText: PropTypes.string,
};

export default Loader;